module.exports = __webpack_public_path__ + "static/media/answerBackground.d3206db7.svg";